import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  savedCourses: [],
  processing: false,
  processingGetMore: false,
  isEmpty: null,
  pagination: {
    CurrentPage: 1,
    TotalPages: 1,
    PageSize: 10,
    TotalCount: 0,
    HasPrevious: false,
    HasNext: false,
  },
};

const getSavedCoursesSlice = createSlice({
  name: "getSavedCourses",
  initialState,
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
      state.savedCourses = [];
      state.isEmpty = null;
    },
    success(state, action) {
      state.processing = false;
      /* TODO: reducer for success*/
      state.savedCourses = action.payload.savedCourses;
      state.pagination = action.payload.pagination;
      if (state.pagination.TotalCount) {
        state.isEmpty = false;
      } else {
        state.isEmpty = true;
      }
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    // get mote
    getMore(state) {
      state.processingGetMore = true;
    },
    getMoreSuccess(state, action) {
      const savedCourses = [
        ...state.savedCourses,
        ...action.payload.savedCourses,
      ];
      return {
        ...state,
        ...action.payload,
        processingGetMore: false,
        savedCourses,
      };
    },
  },
});

const { name, actions, reducer } = getSavedCoursesSlice;
const getSavedCoursesAction = createAction(name);
const getMoreSavedCoursesAction = actions.getMore;

export {
  getSavedCoursesAction,
  getMoreSavedCoursesAction,
  actions as getSavedCoursesActions,
  reducer as getSavedCoursesReducer,
};
